var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLibrary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdaaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4213,
    stopColor: "#ffd8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6519,
    stopColor: "#fed1a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8359,
    stopColor: "#fdc592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9951,
    stopColor: "#fcb47f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcb37e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.88,
    x2: 389.931,
    xlinkHref: "#lg1",
    y1: 176.268,
    y2: 596.365
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 465,
    x2: -135.9,
    xlinkHref: "#lg1",
    y1: 465,
    y2: -135.9
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.984,
    x2: 68.498,
    y1: 390.196,
    y2: -13.284
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a67c52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 66,
    x2: 25.988,
    xlinkHref: "#lg2",
    y1: 255,
    y2: 255
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 145.667,
    y2: 103.37
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#f96f43",
    stopOpacity: 0.029
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    stopColor: "#d26b40",
    stopOpacity: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#b3673d",
    stopOpacity: 0.438
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6354,
    stopColor: "#9e643b",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8257,
    stopColor: "#906339",
    stopOpacity: 0.826
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c6239"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.771,
    x2: 202.271,
    xlinkHref: "#lg3",
    y1: 310.944,
    y2: 235.944
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 509.924,
    x2: 410.565,
    xlinkHref: "#lg3",
    y1: 293.119,
    y2: 233.741
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a98f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bc"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.492,
    x2: 275.351,
    xlinkHref: "#lg4",
    y1: 263.616,
    y2: 263.616
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.703,
    x2: 232.662,
    xlinkHref: "#lg4",
    y1: 263.616,
    y2: 263.616
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.492,
    x2: 238.887,
    xlinkHref: "#lg5",
    y1: 158.497,
    y2: 158.497
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.492,
    x2: 238.887,
    xlinkHref: "#lg5",
    y1: 181.503,
    y2: 181.503
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.492,
    x2: 238.887,
    xlinkHref: "#lg5",
    y1: 345.729,
    y2: 345.729
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.492,
    x2: 238.887,
    xlinkHref: "#lg5",
    y1: 368.735,
    y2: 368.735
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.889,
    x2: 108.06,
    y1: 252.078,
    y2: 213.458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e1dc"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.095,
    x2: 486.954,
    xlinkHref: "#lg5",
    y1: 263.616,
    y2: 263.616
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 410.305,
    x2: 444.265,
    xlinkHref: "#lg5",
    y1: 263.616,
    y2: 263.616
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab272"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.095,
    x2: 450.489,
    xlinkHref: "#lg6",
    y1: 158.497,
    y2: 158.497
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.095,
    x2: 450.489,
    xlinkHref: "#lg6",
    y1: 181.503,
    y2: 181.503
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.095,
    x2: 450.489,
    xlinkHref: "#lg6",
    y1: 345.729,
    y2: 345.729
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 397.095,
    x2: 450.489,
    xlinkHref: "#lg6",
    y1: 368.735,
    y2: 368.735
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.491,
    x2: 319.662,
    xlinkHref: "#lg7",
    y1: 252.078,
    y2: 213.458
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f92814"
  }))), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientTransform: "matrix(.968 .251 -.251 .968 -358.329 143.053)",
    gradientUnits: "userSpaceOnUse",
    x1: 657.398,
    x2: 747.257,
    xlinkHref: "#lg8",
    y1: -57.649,
    y2: -57.649
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientTransform: "matrix(.968 .251 -.251 .968 -358.329 143.053)",
    gradientUnits: "userSpaceOnUse",
    x1: 670.608,
    x2: 704.568,
    xlinkHref: "#lg8",
    y1: -57.649,
    y2: -57.649
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg9"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  }))), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientTransform: "matrix(.968 .251 -.251 .968 -358.329 143.053)",
    gradientUnits: "userSpaceOnUse",
    x1: 657.398,
    x2: 710.792,
    xlinkHref: "#lg9",
    y1: -162.768,
    y2: -162.768
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientTransform: "matrix(.968 .251 -.251 .968 -358.329 143.053)",
    gradientUnits: "userSpaceOnUse",
    x1: 657.398,
    x2: 710.792,
    xlinkHref: "#lg9",
    y1: 47.47,
    y2: 47.47
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientTransform: "matrix(.968 .251 -.251 .968 -358.329 143.053)",
    gradientUnits: "userSpaceOnUse",
    x1: 657.398,
    x2: 710.792,
    xlinkHref: "#lg9",
    y1: 24.341,
    y2: 24.341
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientTransform: "matrix(.968 .251 -.251 .968 -358.329 143.053)",
    gradientUnits: "userSpaceOnUse",
    x1: 684.352,
    x2: 622.611,
    y1: -56.146,
    y2: -72.153
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.906,
    x2: 202.765,
    xlinkHref: "#lg6",
    y1: 263.616,
    y2: 263.616
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.116,
    x2: 160.076,
    xlinkHref: "#lg6",
    y1: 263.616,
    y2: 263.616
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.906,
    x2: 166.3,
    xlinkHref: "#lg4",
    y1: 158.497,
    y2: 158.497
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.906,
    x2: 166.3,
    xlinkHref: "#lg4",
    y1: 368.735,
    y2: 368.735
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.86,
    x2: 78.119,
    y1: 265.119,
    y2: 249.113
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffee83"
  }))), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.319,
    x2: 130.178,
    xlinkHref: "#lg5",
    y1: 263.616,
    y2: 263.616
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.529,
    x2: 87.489,
    xlinkHref: "#lg5",
    y1: 263.616,
    y2: 263.616
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.319,
    x2: 93.714,
    xlinkHref: "#lg8",
    y1: 158.497,
    y2: 158.497
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.319,
    x2: 93.714,
    xlinkHref: "#lg8",
    y1: 368.735,
    y2: 368.735
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.273,
    x2: 5.533,
    xlinkHref: "#lg7",
    y1: 265.119,
    y2: 249.113
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m494.098 433.512h-478.196c-8.782 0-15.902-7.12-15.902-15.903v-325.218c0-8.783 7.12-15.902 15.902-15.902h478.195c8.783 0 15.902 7.12 15.902 15.902v325.219c.001 8.782-7.119 15.902-15.901 15.902z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m486.067 425.453h-462.134c-8.435 0-15.273-6.838-15.273-15.273v-310.36c0-8.435 6.838-15.273 15.273-15.273h462.133c8.435 0 15.273 6.838 15.273 15.273v310.36c.001 8.435-6.837 15.273-15.272 15.273z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m472.591 409.942h-435.181c-7.061 0-12.785-5.724-12.785-12.785v-284.313c0-7.061 5.724-12.785 12.785-12.785h435.181c7.061 0 12.785 5.724 12.785 12.785v284.313c0 7.061-5.724 12.785-12.785 12.785z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m66 100.058h-28.59c-7.061 0-12.785 5.724-12.785 12.785v284.313c0 7.061 5.724 12.785 12.785 12.785h28.59z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m472.59 100.058h-435.18c-7.061 0-12.785 5.724-12.785 12.785v23.157h460.752v-23.156c-.001-7.062-5.725-12.786-12.787-12.786z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m255 120.628 64.017 64.017v224.943h-71.871v-288.96z",
    fill: "url(#SVGID_6_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m485.38 139.03v258.13c0 6.04-4.19 11.09-9.81 12.43h-16.44v-288.96h7.85z",
    fill: "url(#SVGID_7_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m247.146 409.942h-50.722c-6.038 0-10.932-4.895-10.932-10.932v-270.787c0-6.038 4.895-10.932 10.932-10.932h50.722c6.038 0 10.932 4.895 10.932 10.932v270.787c.001 6.037-4.894 10.932-10.932 10.932z",
    fill: "url(#SVGID_8_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m198.703 117.291h46.166v292.651h-46.166z",
    fill: "url(#SVGID_9_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m185.492 153.699h72.587v9.596h-72.587z",
    fill: "url(#SVGID_10_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m185.492 176.705h72.587v9.596h-72.587z",
    fill: "url(#SVGID_11_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m185.492 340.931h72.587v9.596h-72.587z",
    fill: "url(#SVGID_12_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m185.492 363.937h72.587v9.596h-72.587z",
    fill: "url(#SVGID_13_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m206.637 127.787c-6.038 0-10.932 4.895-10.932 10.932v270.787c0 .135.015.266.02.4.232.015.463.035.699.035h50.722c6.038 0 10.932-4.895 10.932-10.932v-270.786c0-.135-.015-.266-.02-.4-.232-.015-.463-.035-.699-.035h-50.722z",
    fill: "url(#SVGID_14_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m458.749 409.942h-50.722c-6.038 0-10.932-4.895-10.932-10.932v-270.787c0-6.038 4.895-10.932 10.932-10.932h50.722c6.038 0 10.932 4.895 10.932 10.932v270.787c0 6.037-4.894 10.932-10.932 10.932z",
    fill: "url(#SVGID_15_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m410.305 117.291h46.166v292.651h-46.166z",
    fill: "url(#SVGID_16_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m397.094 153.699h72.587v9.596h-72.587z",
    fill: "url(#SVGID_17_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m397.094 176.705h72.587v9.596h-72.587z",
    fill: "url(#SVGID_18_)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m397.094 340.931h72.587v9.596h-72.587z",
    fill: "url(#SVGID_19_)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m397.094 363.937h72.587v9.596h-72.587z",
    fill: "url(#SVGID_20_)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m418.24 127.787c-6.038 0-10.932 4.895-10.932 10.932v270.787c0 .135.015.266.02.4.232.015.463.035.699.035h50.722c6.038 0 10.932-4.895 10.932-10.932v-270.786c0-.135-.015-.266-.02-.4-.232-.015-.463-.035-.699-.035h-50.722z",
    fill: "url(#SVGID_21_)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m315.36 409.588-49.094-12.747c-5.844-1.517-9.351-7.485-7.834-13.329l68.052-262.096c1.517-5.844 7.485-9.351 13.329-7.834l49.094 12.747c5.844 1.517 9.351 7.485 7.834 13.329l-68.052 262.096c-1.517 5.844-7.485 9.352-13.329 7.834z",
    fill: "url(#SVGID_22_)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m313.155 409.016-44.684-11.602 73.547-283.259 44.684 11.602z",
    fill: "url(#SVGID_23_)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m387.927 173.605-70.257-18.242 2.411-9.288 70.258 18.242z",
    fill: "url(#SVGID_24_)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m335.092 377.096-70.257-18.242 2.411-9.288 70.257 18.242z",
    fill: "url(#SVGID_25_)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m340.904 354.709-70.257-18.242 2.412-9.288 70.257 18.242z",
    fill: "url(#SVGID_26_)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m347.06 126.309c-5.844-1.517-11.812 1.99-13.329 7.834l-68.052 262.096c-.034.131-.052.262-.081.393.221.073.439.151.668.21l49.094 12.747c5.844 1.517 11.812-1.99 13.329-7.834l68.052-262.096c.034-.131.052-.262.081-.393-.221-.073-.44-.151-.668-.21z",
    fill: "url(#SVGID_27_)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m174.56 409.942h-50.722c-6.038 0-10.932-4.895-10.932-10.932v-270.787c0-6.038 4.895-10.932 10.932-10.932h50.722c6.038 0 10.932 4.895 10.932 10.932v270.787c0 6.037-4.894 10.932-10.932 10.932z",
    fill: "url(#SVGID_28_)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m126.116 117.291h46.166v292.651h-46.166z",
    fill: "url(#SVGID_29_)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m112.906 153.699h72.587v9.596h-72.587z",
    fill: "url(#SVGID_30_)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m112.906 363.937h72.587v9.596h-72.587z",
    fill: "url(#SVGID_31_)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m134.051 127.787c-6.038 0-10.932 4.895-10.932 10.932v270.787c0 .135.015.266.02.4.232.015.463.035.699.035h50.722c6.038 0 10.932-4.895 10.932-10.932v-270.786c0-.135-.015-.266-.02-.4-.232-.015-.463-.035-.699-.035h-50.722z",
    fill: "url(#SVGID_32_)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m101.973 409.942h-50.722c-6.038 0-10.932-4.895-10.932-10.932v-270.787c0-6.038 4.895-10.932 10.932-10.932h50.722c6.038 0 10.932 4.895 10.932 10.932v270.787c0 6.037-4.894 10.932-10.932 10.932z",
    fill: "url(#SVGID_33_)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m53.529 117.291h46.166v292.651h-46.166z",
    fill: "url(#SVGID_34_)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m40.319 153.699h72.587v9.596h-72.587z",
    fill: "url(#SVGID_35_)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m40.319 363.937h72.587v9.596h-72.587z",
    fill: "url(#SVGID_36_)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m61.464 127.787c-6.038 0-10.932 4.895-10.932 10.932v270.787c0 .135.015.266.02.4.232.015.463.035.699.035h50.722c6.038 0 10.932-4.895 10.932-10.932v-270.786c0-.135-.015-.266-.02-.4-.232-.015-.463-.035-.699-.035h-50.722z",
    fill: "url(#SVGID_37_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLibrary);
export default __webpack_public_path__ + "static/media/icon-library.8ed6a96a76b23bf6ce66a20cc50474c5.svg";
export { ForwardRef as ReactComponent };